import { PageTitle, Button, Alert } from '@gsa/afp-component-library';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumbs from '../leasing/components/Breadcrumbs';
import AdditionalVehicleFilters from './additional-vehicle-filters';
import { useEffect, useState } from 'react';
import { NotFound, useCurrentUser, useTitle } from '@gsa/afp-shared-ui-utils';
import { resetAdditionalsState } from '../../reducers/additionals-reducer';
import GSALogoSVG from '../../assets/images/gsa-icon.svg';
import AdditionalRequestTable from './additional-request-table';
import { getRequestSuccessMsg } from './utils/additional-utils';
import { setSelectedStandardItem as setLeasingStandardItem } from '../../reducers/leasing';
import './additional-requests.scss';
import { UserTypes, UserRoles } from '../../constants/index.jsx';

export default function AdditionalVehicles() {
  useTitle('Additional vehicle request | Leasing');
  const navigate = useNavigate();
  const { assetId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const { currentUser } = useCurrentUser();
  const { submitted, status, additionalRequestNumber } = location.state || {};
  const [showingSubmittedAlert, setShowingSubmittedAlert] = useState(submitted);
  const { additionalFilters } = useSelector(
    (state) => state.additionalsReducer,
  );
  const isToggleAdditional = true;
    // window.AFP_CONFIG.appURLs.store.includes('test') ||
    // window.AFP_CONFIG.appURLs.store.includes('dev') ||
    // window.AFP_CONFIG.appURLs.store.includes('local') ||
    // window.AFP_CONFIG.appURLs.store.includes('stg');

  const canCreateAdditional = currentUser?.roles?.some(
    (role) =>
      role.name === UserRoles.CUSTOMER_ADMIN ||
      role.name === UserRoles.SITE_ADMIN ||
      role.name === UserRoles.CUSTOMER_FLEET_MANAGER ||
      role.name === UserRoles.ORDERING_ADMIN,
  );

  useEffect(() => {
    dispatch(resetAdditionalsState(true));
    dispatch(setLeasingStandardItem(null));
  }, []);

  const [notFound, setNotFound] = useState(false);

  //should not display anything if isToggleAdditional is true
  if (!isToggleAdditional) {
    return (
      <NotFound
        goBackLink={{
          href: '/lease',
          text: 'Go back to lease requisitions start',
        }}
      />
    );
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
        }}
      >
        <Breadcrumbs />
        {assetId && (
          <div className="display-flex flex-justify">
            <img className="margin-right-1" src={GSALogoSVG} alt="GSA_logo" />
            <Link
              to={`${window.AFP_CONFIG.appURLs.catalog}/public/fvs/vehicle-standards`}
              target="_blank"
            >
              Federal Vehicle Standards
            </Link>
          </div>
        )}
      </div>
      {showingSubmittedAlert && (
        <Alert
          type="success"
          showClose
          onClose={() => {
            setShowingSubmittedAlert(false);
          }}
        >
          {getRequestSuccessMsg(status, additionalRequestNumber)}
        </Alert>
      )}
      {notFound ? (
        <NotFound
          goBackLink={{
            href: '/lease/vehicle-referral',
            text: 'Go back to lease requisitions start',
          }}
        />
      ) : (
        <>
          <PageTitle title={'Additional vehicle requests'} />
          <div className="margin-top-neg-1">
            Additional requests will be reviewed and evaluated by your agency
            and GSA Fleet. All requests are subject <br /> to funding
            availability, agency policy, and may be filled using existing
            inventory.
          </div>

          <>
            {canCreateAdditional && (
              <Button
                label="Create a new request"
                onClick={() => {
                  let filters = '';
                  additionalFilters?.forEach((filter, idx) => {
                    filters += `${idx === 0 ? '' : '&'}filter-${filter.key}=${filter.value}`;
                  });
                  navigate(`/lease/additionals/request?${filters}`);
                }}
                className="float-right"
                leftIcon={{
                  name: 'add',
                  type: 'button',
                }}
              />
            )}
            <AdditionalVehicleFilters />
            <AdditionalRequestTable />
          </>
        </>
      )}
    </>
  );
}
